import { useTranslation } from "react-i18next";
import { Users, ScanFace, MailPlus, UserPlus2 } from "lucide-react";
import { StatCard } from "../../components/neu/StatCard";

// صف KPI أعلى صفحة الموظفين — نفس أسلوب الصفحة الرئيسية (StatCard ملوّن).
export const EmployeesKpiRow = ({ employees, invites }) => {
  const { t } = useTranslation();
  const total = employees.length;
  const faceReady = employees.filter((e) => e.face_enrolled).length;
  const needFace = total - faceReady;
  const pendingInvites = (invites || []).filter((i) => !i.used).length;

  return (
    <div className="grid grid-cols-2 gap-2.5 sm:gap-4 xl:grid-cols-4" data-testid="employees-kpi-row">
      <StatCard compact testId="kpi-total" tone="indigo" icon={Users}
                label={t("employees.kpi.total")} value={total} />
      <StatCard compact testId="kpi-face-ready" tone="emerald" icon={ScanFace}
                label={t("employees.kpi.faceReady")} value={faceReady}
                hint={total ? `${Math.round((faceReady / total) * 100)}%` : "—"} />
      <StatCard compact testId="kpi-need-face" tone={needFace ? "amber" : "teal"} icon={UserPlus2}
                label={t("employees.kpi.needFace")} value={needFace} />
      <StatCard compact testId="kpi-invites" tone={pendingInvites ? "sky" : "primary"} icon={MailPlus}
                label={t("employees.kpi.invitesPending")} value={pendingInvites} />
    </div>
  );
};
